import {Component, Input} from '@angular/core';
import {Publication} from "../../models/publication.model";
import {PublicationComponent} from "./publication/publication.component";
import {CTMSMilestone} from "../../models/ctmsmilestone.model";
import {CTMSMilestoneComponent} from "./ctmsmilestone/ctmsmilestone.component";
import {RdsDialogService, RdsDividerModule} from "@rds/angular-components";
import {CustomMilestone} from "../../models/custom-milestone.model";
import {CustomMilestoneComponent} from "./custom-milestone/custom-milestone.component";
import {ContextMenuService} from "../../services/context-menu.service";
import {DetailedViewObjectService} from "../../services/detailed-view-object.service";
import {DataObject} from "../../models/metadata";
import {ProcessionDialog} from "../../procession-dialog/procession-dialog.component";
import {TimelineDataService} from "../../services/timeline-data.service";
import {Activity} from "../../models/activity.model";
import {ActivityComponent} from "./activity/activity.component";
import {VVPMActivity} from "../../models/vvpm-activity.model";
import {VVPMActivityComponent} from "./vvpm-activity/vvpm-activity.component";
import {Congress} from "../../models/congress.model";
import {CongressMilestoneComponent} from "./congress-milestone/congress-milestone.component";

export type TimestampData = Array<TimestampBelowEntry> | Array<TimestampAboveEntry>
export type TimestampType = 'below' | 'above'
export type TimestampAboveEntry<T = CTMSMilestone | CustomMilestone | Congress> = {
  entry: T,
  type: "ctmsmilestone" | "custom-milestone" | "congress-event" | "congress-abstract" | "congress-latebreaking"
}
export type TimestampBelowEntry<T = Publication | Activity | VVPMActivity> = {
  entry: T,
  type: "publication" | "activity" | "vvpm-activity"
}


@Component({
  selector: 'app-timestamp',
  standalone: true,
  imports: [
    PublicationComponent,
    CTMSMilestoneComponent,
    RdsDividerModule,
    CustomMilestoneComponent,
    ActivityComponent,
    VVPMActivityComponent,
    CongressMilestoneComponent,
  ],
  templateUrl: './timestamp.component.html',
  styleUrl: './timestamp.component.scss'
})
export class TimestampComponent {
  @Input() data!: TimestampData
  @Input() type!: TimestampType
  @Input() month!: Date


  constructor(private dialogService: RdsDialogService, private contextMenuService: ContextMenuService, private detailedViewObjectService: DetailedViewObjectService, private timelineDataService: TimelineDataService) {
  }

  onDelete(o: DataObject) {
    let dialogRef = this.dialogService.open(ProcessionDialog, {data: {state: 'delete'}})
    dialogRef.afterClosed().subscribe(answer => {
      if(answer)
        this.detailedViewObjectService.deleteObject(o).subscribe(answer => {
          if(answer)
           this.timelineDataService.deleteItem(o)
        })
    })
  }

  onContextMenu(_: MouseEvent){
    if(this.type == 'above'){
      this.contextMenuService.addItemToNextOpen('timestamp-above', (_) => {
        const newCustomMilestone = CustomMilestone.createWithPreselectedDate(this.month)
        this.detailedViewObjectService.nextDetailedObject(newCustomMilestone)
      })
    }
    else{
      this.contextMenuService.addItemToNextOpen('timestamp-below', (_) => {
        const newActivity = Activity.createWithPreselectedDate(this.month)
        this.detailedViewObjectService.nextDetailedObject(newActivity)
      })
    }
  }
}
